import arMessages from "../locales/ar.json";

const ArLang = {
  messages: {
    ...arMessages,
  },
  locale: "ar",
};
export default ArLang;
